// extracted by mini-css-extract-plugin
export var component = "ArticleFeaturedImage-module--component--sYl5D";
export var gatsbyImageWrapper = "ArticleFeaturedImage-module--gatsby-image-wrapper--TRVYr";